module.exports = __webpack_public_path__ + "static/media/vloggi-logo-white.7c41838a.png";